
export const ResizableX = ({ children, roleType }) => (
  <div id="app" style={{height: (roleType === "client" || roleType === "user") ? "calc(100vh - 70px)" : "calc(100vh - 102px)"}}>
    <div className="resizable-x">{children}</div>
  </div>
);

export const ResizableY = ({ children }) => (
  <div className="resizable-y">
    <div className="div1">{children}</div>
  </div>
);
